import { useLinkedContext } from '@context/LinkedItemZoneContext'
import { useAppStore } from '@store'
import { forwardRef } from 'react'
// import GroupWrapper from '../GroupWrapper'
import { LinkedButtonsEditor } from './LinkedButtonsEditor'
import { LinkedEditorWrapper } from './LinkedEditorWrapper'
import LinkedGroupEditor from './LinkedGroupEditor'
import { LinkedGroupSearch } from './LinkedGroupSearch'
import { LinkedObjectZonesEditor } from './LinkedObjectZonesEditor'
import { LinkedSonZones } from './LinkedSonZones'
import LinkedTexturesEditor from './LinkedTexturesEditor'

type PropsLinked = {
  closeFn?: () => void
}

const LinkedItemEditor = forwardRef<HTMLDivElement, PropsLinked>(function LinkedItemEditor(
  { closeFn = () => {} }: PropsLinked,
  ref,
) {
  const { object } = useLinkedContext()
  const isObjectSelected = useAppStore((store) => store.layers[store.currentLayer].selected.size)

  const childrenOrder = object.current?.childrenOrder || []

  const closeLinkedEditor = () => {
    closeFn()
  }

  return (
    <LinkedEditorWrapper closeFn={closeLinkedEditor}>
      <div
        ref={ref}
        className='flex h-[688px] w-[640px] '
      >
        <section className='flex flex-1 flex-col '>
          <LinkedObjectZonesEditor />
          {childrenOrder && (
            <>
              <label
                htmlFor=''
                className='py-15 h-[28px] bg-C/Color4 pl-2 pt-1'
              >
                {'Elementos del grupo'}
              </label>
              <div className='max-h-[350px] overflow-y-auto'>
                {childrenOrder.map((el: string) => (
                  <LinkedSonZones
                    key={el}
                    id={el}
                  />
                ))}
              </div>
            </>
          )}
          <LinkedButtonsEditor closeFn={closeLinkedEditor} />
        </section>
        <section className='flex flex-col overflow-hidden'>
          <article className='flex h-full flex-col overflow-hidden border-l-2 border-r-2 border-C/Color2'>
            <LinkedGroupEditor />
          </article>
          <LinkedGroupSearch />
        </section>
      </div>
      <LinkedTexturesEditor
        closeFn={closeLinkedEditor}
        isObjectSelected={isObjectSelected}
      />
      {/* <GroupWrapper /> */}
    </LinkedEditorWrapper>
  )
})
export default LinkedItemEditor
